import { gsap } from 'gsap';
import { getClosest } from '../../utils';

const getBtns = () => document.querySelectorAll('.js-collapsible-btn');

const open = (content) => {
    gsap.killTweensOf(content);

    gsap.set(content, {
        display: 'block',
        height: 'auto',
        autoAlpha: 0,
    });

    gsap.from(content, {
        duration: content.offsetHeight / 1500,
        height: 0,
        onStart: () => {
            gsap.to(content, {
                autoAlpha: 1,
                duration: content.offsetHeight / 1500,
            });
        },
    });
};

const close = (content) => {
    gsap.killTweensOf(content);

    gsap.to(content, {
        duration: content.offsetHeight / 2500,
        autoAlpha: 0,
        height: 0,
        display: 'none',
    });
};

const clickHandle = (event, btn) => {
    event.preventDefault();

    btn.dataset.open = (btn.dataset.open === undefined ? 'false' : btn.dataset.open);

    const parent = getClosest(btn, '.js-collapsible');
    const content = parent.querySelector('.js-collapsible-content');

    if (btn.dataset.open === 'false') {
        open(content);
    } else {
        close(content);
    }

    btn.dataset.open = (btn.dataset.open === 'false' ? 'true' : 'false');
};

const init = () => {
    const btns = getBtns();
    if (btns.length === 0) return;

    btns.forEach((btn) => {
        // prevent multiple events firing
        const newClickHandle = (event) => {
            clickHandle(event, btn);
        };

        btn.addEventListener('click', newClickHandle);
    });
};

export default init;
